var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("插件介绍")]),
      _vm._v(" "),
      _c("p", [_vm._v("Axis， 坐标轴。")]),
      _vm._v(" "),
      _c("h4", [_vm._v("attr 属性：")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("说明")]),
            _vm._v(" "),
            _c("th", [_vm._v("类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("可选值")]),
            _vm._v(" "),
            _c("th", [_vm._v("默认值")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("orient")]),
            _vm._v(" "),
            _c("td", [_vm._v("坐标轴的方向")]),
            _vm._v(" "),
            _c("td"),
            _vm._v(" "),
            _c("td", [_vm._v("['top','right','bottom','left']")]),
            _vm._v(" "),
            _c("td", [_vm._v("'bottom'")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("name")]),
            _vm._v(" "),
            _c("td", [_vm._v("坐标轴名称")]),
            _vm._v(" "),
            _c("td"),
            _vm._v(" "),
            _c("td"),
            _vm._v(" "),
            _c("td")
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("splitNumber")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_vm._v("0")]),
            _vm._v(" "),
            _c("td", [
              _vm._v("坐标轴的分割段数，同时须设置 visual 的 splitNumber 属性")
            ]),
            _vm._v(" "),
            _c("td")
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("formatter")]),
            _vm._v(" "),
            _c("td", [_vm._v("Function")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("d => d")])]),
            _vm._v(" "),
            _c("td", [_vm._v("文本格式化函数")]),
            _vm._v(" "),
            _c("td")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("style 样式：")]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c(
          "code",
          { pre: true, attrs: { "v-pre": "", class: "language-javascript" } },
          [
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" axis = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Axis({ "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("orient")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'left'")
            ]),
            _vm._v(" })\naxis.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'scale'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-literal" } }, [
              _vm._v("false")
            ]),
            _vm._v(")\n")
          ]
        )
      ]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("基本类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("说明")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("axis")]),
            _vm._v(" "),
            _c("td", [_vm._v("线")]),
            _vm._v(" "),
            _c("td", [_vm._v("坐标轴样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("name")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本")]),
            _vm._v(" "),
            _c("td", [_vm._v("坐标轴名字")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("scale")]),
            _vm._v(" "),
            _c("td", [_vm._v("线")]),
            _vm._v(" "),
            _c("td", [_vm._v("坐标轴上的刻度")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("label")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本")]),
            _vm._v(" "),
            _c("td", [_vm._v("坐标轴上文本类型")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }